import { cn } from "@faire/prototype-playground/lib/utils";
import { usePlaygroundLocalMsg } from "@faire/prototype-playground/platform/localization";
import { CaretLeft, X } from "@phosphor-icons/react";

type RetailerMobileNavProps = {
  progressFraction?: number;
  showProgress?: boolean;
  showBack?: boolean;
  showClose?: boolean;
  onBack?: () => void;
  onClose?: () => void;
};

export const RetailerMobileNav = ({
  progressFraction = 0,
  showProgress = true,
  showBack = true,
  showClose = false,
  onBack,
  onClose,
}: RetailerMobileNavProps) => {
  const backLabel = usePlaygroundLocalMsg("Go back");
  const closeLabel = usePlaygroundLocalMsg("Close");

  return (
    <header className="bg-fs-surface-primary sticky top-0 z-10 shrink-0">
      <div className="border-fs-border-muted relative flex h-14 items-center justify-center border-b px-(--slate-dimensions-2)">
        {showBack ? (
          <button
            type="button"
            aria-label={backLabel}
            className="text-fs-text-primary absolute left-(--slate-dimensions-2) flex size-11 items-center justify-center"
            onClick={onBack}
          >
            <CaretLeft size={16} weight="regular" />
          </button>
        ) : null}
        <img src="/images/faire-logo.svg" alt="Faire" className="h-3 w-auto" />
        {showClose ? (
          <button
            type="button"
            aria-label={closeLabel}
            className="text-fs-text-primary absolute right-(--slate-dimensions-2) flex size-11 items-center justify-center"
            onClick={onClose}
          >
            <X size={16} weight="regular" />
          </button>
        ) : null}
      </div>
      {showProgress ? (
        <div className="bg-fs-surface-tertiary flex h-1 w-full">
          <div
            className={cn(
              "bg-fs-action-surface-default h-full transition-[width] duration-300"
            )}
            style={{
              width: `${Math.min(Math.max(progressFraction, 0), 1) * 100}%`,
            }}
          />
        </div>
      ) : null}
    </header>
  );
};
